module.exports = __webpack_public_path__ + "static/img/partner-logo-5.fc611ae8.png";